import { Box, DialogContent, Theme } from '@mui/material';
import { Controller, FieldValues, useFormContext } from 'react-hook-form';
import { Feature } from '@loyalty/shared-common';
import { FieldPath } from 'react-hook-form/dist/types';
import { QlfCodeArea } from '@qualifio/ui-commons/dist/components/qlf-code-area';
import { makeStyles } from '@mui/styles';
import { useFeatures } from '../../../../features/FeaturesContext';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  dialogContent: {
    paddingTop: spacing(2),
    paddingBottom: spacing(1),
    height: '75vh',
  },
  htmlEditor: {
    height: '55vh',
  },
}));

export function CodeTab<T extends FieldValues>({
  name,
  language,
  defaultValue,
}: {
  name: FieldPath<T>;
  language: 'css' | 'javascript' | 'html';
  defaultValue?: string;
}) {
  const classes = useStyles();

  const { control } = useFormContext<T>();
  const { features } = useFeatures();
  const { write: templateJsWrite } = features[Feature.TEMPLATE_JS];

  return (
    <DialogContent className={classes.dialogContent}>
      <Box
        sx={{
          margin: '0 auto',
          minHeight: 400,
          height: '100%',
          'section > div': {
            height: '100%',
          },
        }}
      >
        <Controller
          control={control}
          name={name}
          render={({ field: { ref, value, ...field } }) => (
            <QlfCodeArea
              {...field}
              value={value as string}
              className={classes.htmlEditor}
              allowFullScreen
              defaultLanguage={language}
              defaultValue={defaultValue}
              height="100%"
              options={{
                readOnly: name === 'js' && !templateJsWrite,
              }}
            />
          )}
        />
      </Box>
    </DialogContent>
  );
}
